<div class="playlists-container">

  <div class="content" #cont>
<!--    <div class="breadcrumbs">-->
<!--      <a routerLink="/playlists"> Playlists </a>-->
<!--      <mat-icon>keyboard_arrow_right</mat-icon>-->
<!--      <span>{{playlistName}}</span>-->
<!--    </div>-->

    <h4 class="pb-24 pt-24">{{playlistName}}</h4>


    <div #tracksList>
      @if(playlistTracks.length > 0) {
        <app-tracks-list
          [dataSource]="playlistsStore.tracks()"
          [tracksTotal]="playlistsStore.tracksTotal()"
          [isLoading]="playlistsStore.isTracksLoading()"
          (sortChanged)="sortChange($event)"
          (pageChanged)="changePage($event)"
          (downloadClicked)="download($event)"
        ></app-tracks-list>
      }
    </div>
  </div>

  <div class="sidebar">
    <h4 class="pb-24">Top 20</h4>

    <app-top-tracks></app-top-tracks>
  </div>
</div>
